import Invoice from 'model/Invoice'
import modalInvoiceInfo from './view/modalInvoiceInfo.html'
import { parseOfdDocument, renderOfd } from '../../../../../vendor/ofd/ofd'
class modalInvoiceDetailCtrl {
  constructor(
    $scope,
    $uibModalInstance,
    items1,
    httpRequest,
    logger,
    formvalidateApi,
    globalFn,
    $uibModal,
    hasPDFReader
  ) {
    $('#QRCode-auto-focus').hide()
    const uploadList = items1.uploadListData
    const { currentInvoicId } = items1
    $scope.datetimepicker = {
      autoclose: true,
      minView: 'month',
      language: 'zh-CN',
      format: 'yyyy-mm-dd',
      forceParse: 0,
      pickTime: false,
      pickerPosition: 'top-right',
    }
    httpRequest.post_getSysParam({ params: ['ivat_invoice_verify_conf'] }).then((res) => {
      $scope.isClose = res.data.value[0].paramValue == 0 ? true : false
      // console.log(res.data.value[0].paramValue)
    })
    $scope.init = function (paramId) {
      httpRequest.get_selectBillDetailById(paramId).then((res) => {
        $scope.reimburseDeitalFrom = res.data.value
        $scope.uploadJson = JSON.stringify($scope.reimburseDeitalFrom)
        $scope.invoiceType = $scope.reimburseDeitalFrom.invoiceType
        $scope.selectedInvoiceType = ''
        // if ($scope.invoiceType == '-1') {
        httpRequest.get_dictByTypeArr(['ivat_inv_type', 'ovat_tax_rate']).then((res) => {
          $scope.dictionary = res.data.value
          $scope.ivatTaxRate = res.data.value.ovat_tax_rate
        })
        // }
        $scope.ispdf = false // 票据影像类型
        $scope.isofd = false // 票据影像类型OFD
        $scope.noimg = false // 无票据影像类型
        $scope.isNormalInvoice =
          $scope.invoiceType == '0' ||
          $scope.invoiceType == '2' ||
          $scope.invoiceType == '51' ||
          $scope.invoiceType == '12' ||
          $scope.invoiceType == '14' ||
          $scope.invoiceType == '41' ||
          $scope.invoiceType == '15' ||
          $scope.invoiceType == '111'
        for (let i = 0; i < uploadList.length; i++) {
          if (uploadList[i].invoiceId == paramId) {
            $scope.currentIndex = i
            break
          }
        }
        $scope.showPreTask = $scope.currentIndex != 0
        $scope.showNextTask = $scope.currentIndex != uploadList.length - 1
        // 截取验证码 切换图片
        if ($scope.reimburseDeitalFrom.checkCode) {
          $scope.reimburseDeitalFrom.checkCode = $scope.reimburseDeitalFrom.checkCode.substring(
            $scope.reimburseDeitalFrom.checkCode.length - 6
          )
        }
        if (
          $scope.reimburseDeitalFrom.fileInfo &&
          $scope.reimburseDeitalFrom.fileInfo.fileType == 'pdf'
        ) {
          $scope.ispdf = true
          if (hasPDFReader()) $scope.canShowPDF = true
          if (window.ActiveXObject || 'ActiveXObject' in window) {
            $scope.needConfig = true
          }
          // $timeout(() => {
        }
        if (
          $scope.reimburseDeitalFrom.fileInfo &&
          $scope.reimburseDeitalFrom.fileInfo.fileType == 'ofd'
        ) {
          $scope.isofd = true
          let file = null
          const fileUrl = `${host.etcloudIvatApp}common/common/getFile?fileKey=${$scope.reimburseDeitalFrom.fileInfo.storageKey}`
          $scope
            .getFileFromUrl(fileUrl, $scope.reimburseDeitalFrom.fileInfo.fileName)
            .then((response) => {
              file = response
              $scope.getOfdDocumentObj(response, document.body.clientWidth)
            })
            .catch((e) => {
              console.error(e)
            })
        }
        const imagKey = $scope.reimburseDeitalFrom.fileInfo
          ? $scope.reimburseDeitalFrom.fileInfo.storageKey
          : ''
        if ($scope.reimburseDeitalFrom.fileInfo) {
          $scope.imgSrc = `${host.etcloudIvatApp}common/common/getFile?fileKey=${imagKey}`
        } else {
          $scope.noimg = true
          $scope.imgSrc = ''
          if ($scope.reimburseDeitalFrom.verifyStatus == 1) {
            httpRequest
              .get_getInvoice({
                invoiceCode: $scope.reimburseDeitalFrom.invoiceCode,
                invoiceNumber: $scope.reimburseDeitalFrom.invoiceNumber,
              })
              .then((res) => {
                $scope.invoice = new Invoice(res.data.value)
                $scope.invoice.invType = $scope.invoice.invoiceType
                $scope.invoice.chineseAmtTotal = globalFn.digitUppercase(
                  $scope.invoice.adValoremTotal
                )
                if (
                  res.data.value.invoiceType == '41' ||
                  res.data.value.invoiceType == '12' ||
                  res.data.value.invoiceType == '15'
                )
                  $scope.codeVersions = $scope.invoice.details[0].revenueVersion
              })
          }
        }
      })
    }
    $scope.init(currentInvoicId)
    $scope.init(currentInvoicId)
    //url转为files文件流
    $scope.getFileFromUrl = function (url, fileName) {
      return new Promise((resolve, reject) => {
        var blob = null
        var xhr = new XMLHttpRequest()
        xhr.open('GET', url)
        xhr.setRequestHeader('Accept', 'application/ofd')
        xhr.responseType = 'blob'
        // 加载时处理
        xhr.onload = () => {
          // 获取返回结果
          blob = xhr.response
          let file = new File([blob], fileName, { type: 'application/ofd' })
          // 返回结果
          resolve(file)
        }
        xhr.onerror = (e) => {
          reject(e)
        }
        // 发送
        xhr.send()
      })
    }
    //调用ofdJS绘制 文件格式为OFD的发票
    $scope.getOfdDocumentObj = function (file, screenWidth) {
      parseOfdDocument({
        ofd: file,
        success(res) {
          const divs = renderOfd(screenWidth, res[0])
          $scope.displayOfdDiv(divs)
        },
        fail(error) {
          console.log(error)
        },
      })
    }
    $scope.displayOfdDiv = function (divs) {
      let contentDiv = document.getElementById('content')
      contentDiv.innerHTML = ''
      for (const div of divs) {
        contentDiv.appendChild(div)
      }
    }

    $scope.$watch('currentIndex', (newValue) => {
      // 控制页码显示
      if (newValue < 1) {
        $scope.showPreTask = false
      } else {
        $scope.showPreTask = true
      }
      if (newValue >= uploadList.length - 1) {
        $scope.showNextTask = false
      } else {
        $scope.showNextTask = true
      }
    })

    $scope.changeTask = function (
      changeFlag // -1上一条 1下一条
    ) {
      if (
        ($scope.currentIndex <= 0 && changeFlag == -1) ||
        ($scope.currentIndex >= uploadList.length - 1 && changeFlag == 1)
      ) {
        return
      }
      if (changeFlag == 1) {
        $scope.currentIndex += 1
      } else if (changeFlag == -1) {
        $scope.currentIndex -= 1
      }
      $scope.init(uploadList[$scope.currentIndex].invoiceId)
    }

    $scope.getArea = function getArea(key) {
      return httpRequest
        .get_getSysSfdqDmList({
          key,
        })
        .then((res) => res.data.value)
    }
    $scope.$watch('invoiceType', () => {
      if ($scope.invoiceType == 104) $scope.reimburseDeitalFrom.taxRate = 0.03
      if ($scope.invoiceType == 102 || $scope.invoiceType == 103)
        $scope.reimburseDeitalFrom.taxRate = 0.09

      // $scope.compute()
    })
    $scope.changeInvoiceType = function (invoiceCode) {
      console.log(invoiceCode)
      // 类型为-1 手动选择发票类型
      $scope.isNormalInvoice =
        $scope.invoiceType == '0' ||
        $scope.invoiceType == '2' ||
        $scope.invoiceType == '51' ||
        $scope.invoiceType == '12' ||
        $scope.invoiceType == '14' ||
        $scope.invoiceType == '41' ||
        $scope.invoiceType == '15' ||
        $scope.invoiceType == '111' || //区块链电子发票
        invoiceCode == '0' ||
        invoiceCode == '2' ||
        invoiceCode == '51' ||
        invoiceCode == '12' ||
        invoiceCode == '14' ||
        invoiceCode == '41' ||
        invoiceCode == '15' ||
        invoiceCode == '111'
      $scope.reimburseDeitalFrom = []
      $scope.reimburseDeitalFrom = JSON.parse($scope.uploadJson)
      $scope.reimburseDeitalFrom.invoiceType = invoiceCode
      $scope.selectedInvoiceType = invoiceCode
      if ($scope.reimburseDeitalFrom.checkCode) {
        $scope.reimburseDeitalFrom.checkCode = $scope.reimburseDeitalFrom.checkCode.substring(
          $scope.reimburseDeitalFrom.checkCode.length - 6
        )
      }
      if (invoiceCode == '102' || invoiceCode == '103') {
        $scope.reimburseDeitalFrom.taxRate = 0.09
      } else if (invoiceCode == '104') {
        $scope.reimburseDeitalFrom.taxRate = 0.03
      }
      $scope.compute()
    }

    $scope.cancel = () => {
      $uibModalInstance.close()
    }
    $scope.ok = () => {
      const reg = /^([01]\d|2[01234]):([0-5]\d|60)$/
      if ($scope.reimburseDeitalFrom.getTime && !reg.test($scope.reimburseDeitalFrom.getTime)) {
        if ($scope.reimburseDeitalFrom.invoiceType == '108')
          return logger.logError('开始时间格式错误,格式应为HH:MM')
        return logger.logError('上车时间格式错误,格式应为HH:MM')
      }
      if ($scope.reimburseDeitalFrom.offTime && !reg.test($scope.reimburseDeitalFrom.offTime)) {
        if ($scope.reimburseDeitalFrom.invoiceType == '108')
          return logger.logError('结束时间格式错误,格式应为HH:MM')
        return logger.logError('下车时间格式错误,格式应为HH:MM')
      }

      if ($scope.invoiceType == '-1' && $scope.selectedInvoiceType == '') {
        logger.logError('未知发票类型，请手动填写发票信息')
        return
      }
      const ret = formvalidateApi.run()
      if (ret) {
        let isUnknowType = false
        if ($scope.reimburseDeitalFrom.invoiceType == '-1') {
          isUnknowType = true
          $scope.reimburseDeitalFrom.invoiceType = $scope.selectedInvoiceType
        }
        if (
          $scope.reimburseDeitalFrom.invoiceType !== '105' &&
          $scope.reimburseDeitalFrom.invoiceDate == ''
        ) {
          // 除了定额发票其余日期必填
          logger.logError('日期为必填项')
          return
        }
        httpRequest.post_invoiceProofread($scope.reimburseDeitalFrom).then((res) => {
          if (res.data.success) {
            logger.logSuccess('保存成功')
            $uibModalInstance.close(res.data.value)
          } else if (isUnknowType) {
            $scope.reimburseDeitalFrom.invoiceType = '-1'
          }
        })
      }
    }
    // 计算金额
    $scope.compute = function compute() {
      $scope.reimburseDeitalFrom.ticketPrice = $scope.reimburseDeitalFrom.ticketPrice || 0
      $scope.reimburseDeitalFrom.fuelSurcharge = $scope.reimburseDeitalFrom.fuelSurcharge || 0
      $scope.reimburseDeitalFrom.constructionFee = $scope.reimburseDeitalFrom.constructionFee || 0
      $scope.reimburseDeitalFrom.otherTaxes = $scope.reimburseDeitalFrom.otherTaxes || 0
      if ($scope.reimburseDeitalFrom.invoiceType == 102 || $scope.selectedInvoiceType == 102) {
        $scope.reimburseDeitalFrom.totalTaxamt = globalFn.Mul(
          0.09,
          globalFn.Div(
            globalFn.Add(
              $scope.reimburseDeitalFrom.ticketPrice,
              $scope.reimburseDeitalFrom.fuelSurcharge
            ),
            1.09
          )
        )
        $scope.reimburseDeitalFrom.totalTaxamt =
          Math.round($scope.reimburseDeitalFrom.totalTaxamt * Math.pow(10, 2)) / Math.pow(10, 2)
        $scope.reimburseDeitalFrom.totalSum =
          $scope.reimburseDeitalFrom.ticketPrice +
          $scope.reimburseDeitalFrom.fuelSurcharge +
          $scope.reimburseDeitalFrom.constructionFee +
          $scope.reimburseDeitalFrom.otherTaxes
        $scope.reimburseDeitalFrom.totalSum =
          Math.round($scope.reimburseDeitalFrom.totalSum * Math.pow(10, 2)) / Math.pow(10, 2)
      } else if (
        $scope.reimburseDeitalFrom.invoiceType == 103 ||
        $scope.selectedInvoiceType == 103 ||
        $scope.reimburseDeitalFrom.invoiceType == 104 ||
        $scope.selectedInvoiceType == 104
      ) {
        $scope.reimburseDeitalFrom.totalTaxamt = globalFn.Mul(
          $scope.reimburseDeitalFrom.taxRate,
          globalFn.Div(
            $scope.reimburseDeitalFrom.ticketPrice,
            globalFn.Add($scope.reimburseDeitalFrom.taxRate, 1)
          )
        )
        $scope.reimburseDeitalFrom.totalTaxamt =
          Math.round($scope.reimburseDeitalFrom.totalTaxamt * Math.pow(10, 2)) / Math.pow(10, 2)
      } else if (
        $scope.reimburseDeitalFrom.invoiceType == 105 ||
        $scope.reimburseDeitalFrom.invoiceType == 105
      ) {
        if ($scope.reimburseDeitalFrom.number < 1) {
          $scope.reimburseDeitalFrom.number = 1
        }
        if (
          $scope.reimburseDeitalFrom.oneAmount == null ||
          $scope.reimburseDeitalFrom.oneAmount < 0
        ) {
          $scope.reimburseDeitalFrom.oneAmount = null
          $scope.reimburseDeitalFrom.totalSum = null
          return
        }
        $scope.reimburseDeitalFrom.totalSum = (
          $scope.reimburseDeitalFrom.oneAmount * $scope.reimburseDeitalFrom.number
        ).toFixed(2)
        $('.tyde-totalSum').removeClass('has-error')
        $('.tyde-totalSum').find('.erro_msg').empty()
      }
    }
    $scope.checkSuccess = function (item) {
      $('iframe').hide()
      $uibModal
        .open({
          template: modalInvoiceInfo,
          openedClass: 'mod-modal mod-invoice-info',
          animation: true,
          controller: 'modalInvoiceInfo',
          resolve: {
            invoice() {
              return {
                invoiceCode: item.invoiceCode,
                invoiceNumber: item.invoiceNumber,
              }
            },
          },
        })
        .result.then()
        .finally(() => {
          $('iframe').show()
        })
    }
  }
}

modalInvoiceDetailCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'items1',
  'httpRequest',
  'logger',
  'formvalidateApi',
  'globalFn',
  '$uibModal',
  'hasPDFReader',
]
export default modalInvoiceDetailCtrl



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/reimbursement/modalInvoiceDetailCtrl.js